import PropTypes from 'prop-types'
import styles from './styles/ToastContentContainer.css'
import toast from 'react-hot-toast'

export const ToastContentContainer = ({ mainText, toastID, actionLabel, actionHandler }) => {
  return (
    <span className={styles.toastContainer}>
      <span className={styles.toastText}>{mainText}</span>
      {actionLabel && actionHandler && (
        <span className={styles.toastActionLink} onClick={actionHandler}>
          {actionLabel}
        </span>
      )}
      <span
        className={styles.toastDismissIcon}
        onClick={() => toast.dismiss(toastID)}
        title='Dismiss'
        role='button'
        tabIndex={0}
        aria-label='Dismiss'
      >
        <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <line
            x1='4.35355'
            y1='4.64645'
            x2='13.3536'
            y2='13.6464'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
          />
          <line
            x1='13.3536'
            y1='4.64645'
            x2='4.35355'
            y2='13.6464'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
          />
        </svg>
      </span>
    </span>
  )
}

ToastContentContainer.defaultProps = {
  actionLabel: '',
  actionHandler: null
}

ToastContentContainer.propTypes = {
  mainText: PropTypes.string.isRequired,
  toastID: PropTypes.string.isRequired,
  actionLabel: PropTypes.string,
  actionHandler: PropTypes.func
}

export default ToastContentContainer
